module.exports = __webpack_public_path__ + "media/images/homes/set-7a0bb5066aa174ba6b170cd07f9f9c3f.svg";